<section class="pages">
  <div
    class="text-center col-12"
    style="padding: 20px 0 60px 0"
    *ngIf="loading"
  >
    <app-spinner></app-spinner>
  </div>
  <div
    *ngIf="loading === false && consents.length && verified"
    style="display: flex; flex-direction: column"
  >
    <h1 style="margin: 0" translate>
      components.list.unsubscribe.updatePreferences
    </h1>
    <h3 translate>{{ emailUser }}</h3>
    <h3 translate>components.list.unsubscribe.notYourEmail</h3>
    <div *ngIf="action === 'manage'">
      <div
        *ngIf="loading === false && consents.length"
        style="display: flex; flex-direction: column"
      >
        <!-- <h2 translate>components.list.unsubscribe.select</h2> -->
        <span>
          <mat-checkbox
            class="margin"
            [checked]="allComplete"
            color="primary"
            [indeterminate]="someComplete()"
            (change)="setAll($event.checked)"
          >
            <span translate>
              components.list.unsubscribe.selectAll
            </span>
          </mat-checkbox>
        </span>
        <span
          *ngFor="let consent of consents"
          style="
            background: #f0f7fc !important;
            border: 1px solid #e0e7ec !important;
            padding: 15px !important;
            width: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
          "
        >
          <mat-checkbox
            [(ngModel)]="consent.completed"
            [disabled]="consent.id === '9444712'"
            color="primary"
            (ngModelChange)="updateAllComplete()"
            translate
          >
            <div style="display: flex; flex-direction: column">
              <span translate style="font-weight: bold">{{
                consent.name
              }}</span>
              <span translate>{{ consent.description }}</span>
            </div>
          </mat-checkbox>
        </span>
      </div>
    </div>
    <div class="buttons">
      <button
        *ngIf="action === 'manage'"
        class="btn btn-primary input"
        translate
        style="width: fit-content"
        (click)="unsubscribe()"
      >
        <!-- components.list.unsubscribe.unsubscribe -->
        components.list.unsubscribe.updatePreferences
      </button>
      <button
        *ngIf="action === 'unsubscribe'"
        class="btn btn-primary input"
        translate
        style="width: fit-content"
        (click)="unsubscribe(true)"
      >
        components.list.unsubscribe.noMoreCallsOrMessages
      </button>

      <button
        class="btn btn-primary input"
        translate
        style="width: fit-content"
        [routerLink]="['/']"
      >
        components.list.unsubscribe.cancel
      </button>
    </div>
  </div>
  <div *ngIf="!loading && !verified">
    <h2>Tu email no esta verificado</h2>
    <h3>Para reenviarte el correo de verificacion haz click <span class="link" (click)="resendEmail()">aquí</span></h3>
  </div>
  <div *ngIf="loading === false && consents.length === 0">
    <span translate>components.list.unsubscribe.errorOccurred</span>
  </div>
</section>
